const defaultState = {
    zonesList: [],
    mode: '',
    searchText: '',
    editedZoneId: null,
    highlightedZoneId: null,
    presetColors: ['#F569CA', '#A857DA', '#016BFC', '#23C0DE', '#25C78D', '#FDB22E', '#FB8F31', '#E53C3C'],
    zoneData: {
        type: 'CIRCLE',
        zoneName: '',
        address: '',
        latitude: '',
        longitude: '',
        radius: 0.01,
        color: '#F569CA',
        polygonCoords: [],
        polygonHistory: [],
    }
};

const zones = (state = defaultState, action) => {
    switch (action.type) {
        case 'SET_ZONES_LIST':
            return { ...state, zonesList: action.payload.map(zone => ({
                    ...zone,
                    shape_color: zone.shape_color || '#F569CA'
                })) }
        case 'SET_MODE':
            return { ...state, mode: action.payload }
        case 'SET_SEARCH_TEXT':
            return { ...state, searchText: action.payload }
        case 'SET_PRESET_COLORS':
            return {
                ...state,
                presetColors: [action.payload, ...state.presetColors].slice(0, state.presetColors.length)
            };
        case 'SET_EDITED_ZONE_ID':
            return { ...state, editedZoneId: action.payload }
        case 'SET_HIGHLIGHTED_ZONE_ID':
            return { ...state, highlightedZoneId: action.payload }
        case 'SET_ZONE_DATA_VALUES':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    ...action.payload
                }
            };
        case 'ADD_POLYGON_POINT':
            const points = state.zoneData.polygonCoords || [];
            const last = points[points.length - 1];

            if (
                last &&
                last.lat === action.payload.lat &&
                last.lng === action.payload.lng
            ) {
                return state;
            }

            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: [
                        ...points,
                        action.payload
                    ]
                }
            };
        case 'UNDO_POLYGON_POINT':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: state.zoneData.polygonCoords.slice(0, -1)
                }
            };
        case 'UNDO_POLYGON_HISTORY':
            const history = state.zoneData.polygonHistory || [];

            if (!history.length) {
                return state;
            }

            const previous = history[history.length - 1];

            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: previous,
                    polygonHistory: history.slice(0, -1)
                }
            };
        case 'EDIT_POLYGON_POINT':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: state.zoneData.polygonCoords.map((coord, index) =>
                        index === action.payload.index ? { ...coord, [action.payload.key]: action.payload.value } : coord
                    )
                }
            };
        case 'MOVE_POLYGON_POINT':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonHistory: [
                        ...(state.zoneData.polygonHistory || []),
                        structuredClone(
                            state.zoneData.polygonCoords
                        )
                    ],
                    polygonCoords:
                        state.zoneData.polygonCoords.map(
                            (point, idx) =>
                                idx === action.payload.index
                                    ? {
                                        ...point,
                                        lat: action.payload.lat,
                                        lng: action.payload.lng
                                    }
                                    : point
                        )
                }
            };
        case 'CLEAR_POLYGON_POINT':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: state.zoneData.polygonCoords.filter((coord, index) => index !== action.payload.index)
                }
            };
        case 'CLEAR_POLYGON':
            return {
                ...state,
                zoneData: {
                    ...state.zoneData,
                    polygonCoords: []
                }
            };
        case 'INITIALIZE_ZONE_DATA':
            return {
                ...state,
                zoneData: {
                    ...defaultState.zoneData,
                    ...action.payload,
                    polygonCoords: action.payload.polygonCoords || []
                }
            };
        case 'RESET_ZONE_DATA':
            return {
                ...state,
                zoneData: action.payload
                    ? { ...defaultState.zoneData, ...action.payload }
                    : { ...defaultState.zoneData }
            };
        default:
            return state
    }
};

export default zones;
